import { Diary, HarloweSupport, Note, NoteAddendum, ReceivedEmail, SentEmail, User } from "@harlowe/core";
import { EncounterFilter } from "../../services/encounter.service";
import { TealHealthEncounter, TealHealthEncounterHeader } from "../../models/encounter";

export namespace Encounters
{

    export class PersistState
    {
        static readonly type="[Encounter State] Persist";
    }

    export class UserLoggedIn
    {
        static readonly type = "[Encounter Login Action] Successful Login";
        constructor(public payload: { user: User }) {}
    }
    
    export class EncounterFilterSet
    {
        static readonly type = "[Anywhere] Encounter Filter Set"
        constructor(public payload: {filter: EncounterFilter}) {}
    }   

    export class EncounterOpenedFromEncounterManager
    {
        static readonly type = "[Encounter Manager] Encounter Opened";
        constructor(public payload: {header: TealHealthEncounterHeader}){}
    }


    export class WorkbenchEncounterClosed
    {
        static readonly type = "[Workbench] Encounter Closed";
        constructor(public payload: {encounter: TealHealthEncounter}){}
    }

    export class EncounterSelected
    {
        static readonly type = "[Workbench] Encounter Selected"
        constructor(public payload: {encounterId: number}) {}
    }

    export class DiaryUpdated
    {
        static readonly type="[Encounter Service] Diary Updated";
        constructor(public payload: {encounterId: number, diary: Diary}){}
    }

    export class DiaryAdded
    {
        static readonly type="[Encounter Service] Diary Added";
        constructor(public payload: {encounterId: number, diary: Diary}){}
    }

    export class NoteUpdated
    {
        static readonly type="[Encounter Service] Note Updated";
        constructor(public payload: {encounterId: number, note: Note}){}
    }

    export class NoteDeleted
    {
        static readonly type="[Encounter Service] Note Deleted";
        constructor(public payload: {encounterId: number, noteId: number}){}
    }
    
    export class NoteAdded
    {
        static readonly type="[Encounter Service] Note Added";
        constructor(public payload: {encounterId: number, note: Note}){}
    }

    export class NoteAddendumAdded
    {
        static readonly type="[Encounter Service] Note Addendum Added";
        constructor(public payload: {encounterId: number, noteId: number, addendum: NoteAddendum}){}
    }

    export class EncounterServiceEncounterEmailSent
    {
        static readonly type="[Encounter Service] Email Sent";
        constructor(public payload:{encounterId: number, email: SentEmail}){};
    }
    export class EncounterServiceEncounterEmailReceived
    {
        static readonly type="[Encounter Service] Email Received";
        constructor(public payload:{encounterId: number, email: ReceivedEmail}){};
    }
    export class EncounterServiceAttachmentAdded
    {
        static readonly type="[Encounter Service] Attachment Added";
        constructor(public payload:{encounterId: number, file: HarloweSupport.File}){};
    }
    export class EncounterServiceAttachmentsAdded
    {
        static readonly type="[Encounter Service] Attachment Added";
        constructor(public payload:{encounterId: number, files: HarloweSupport.File[]}){};
    }
    export class EncounterServiceAttachmentDeleted
    {
        static readonly type="[Encounter Service] Attachment Deleted";
        constructor(public payload:{encounterId: number, file: HarloweSupport.File}){};
    }
}